import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {NextButton} from '../../UI/NextButton';
import {ModuleFrame} from '../../parts/ModuleFrame';
import Split from 'react-split';

export const PhotoModule = ({number, id, data, onNext, previewMode = false}) => {
  const [nextButtonShow, setNextButtonShow] = useState(false);
  const [moduleWidthCoef, setModuleWidthCoef] = useState(0);
  const [topSizes, setTopSizes] = useState(
    [...Array(data.topPhotoList.length)].map(i => 1 / data.topPhotoList.length * 100)
  );
  const [bottomSizes, setBottomSizes] = useState(
    [...Array(data.bottomPhotoList.length)].map(i => 1 / data.bottomPhotoList.length * 100)
  );
  const sliderColor = data.sliderColor ? data.sliderColor.replace('#', '') : '000';

  function handleTopResize(values) {
    setTopSizes(values);
    setNextButtonShow(true);
  }

  function handleBottomResize(values) {
    setBottomSizes(values);
    setNextButtonShow(true);
  }

  useEffect(() => {
    setNextButtonShow(false);
  }, []);

  return (
    <ModuleFrame fontFamily={data.fontFamily} onChangeModuleWidthCoef={(value) => setModuleWidthCoef(value)}>

      <Box
        sliderColor={sliderColor}
        height={`${50 - (data.middleTextBox.position === 'inside' ? data.middleTextBox.height / 2 : 0)}%`}
        direction={data.topTextBox.position === 'right' ? 'row' : 'row-reverse'}
      >
        <StyledSplit
          width={`${100 - (data.topTextBox.position !== 'none' ? data.topTextBox.width : 0)}`}
          minSize={[...Array(data.topPhotoList.length)].map(i => 0)}
          sizes={topSizes}
          onDragEnd={handleTopResize}
          snapOffset={0}
          gutterSize={0}
        >
          {
            data.topPhotoList.map((item, i) => <PhotoItem key={`${id}_top_${i}`} background={item && item.image}></PhotoItem>)
          }
        </StyledSplit>

        <BoxText
          position={data.topTextBox.position}
          background={data.topTextBox.background}
          width={data.topTextBox.width}
        >
          <StyledText
            position={data.topTextBoxPosition}
            sizes={data.topTextBoxSize}
            color={data.topTextBox.color}
            fontSize={data.topTextBox.fontSize * moduleWidthCoef}
            dangerouslySetInnerHTML={{__html: data.topText}}
          ></StyledText>
        </BoxText>
      </Box>

      <MiddleText
        position={data.middleTextBox.position}
        background={data.middleTextBox.background}
        width={data.middleTextBox.position === 'cover' ? data.middleTextBox.width : '100'}
        height={data.middleTextBox.height}
      >
        <StyledText
          position={data.middleTextBoxPosition}
          sizes={data.middleTextBoxSize}
          color={data.middleTextBox.color}
          fontSize={data.middleTextBox.fontSize * moduleWidthCoef}
          dangerouslySetInnerHTML={{__html: data.middleText}}
        ></StyledText>
      </MiddleText>

      <Box
        sliderColor={sliderColor}
        height={`${50 - (data.middleTextBox.position === 'inside' ? data.middleTextBox.height / 2 : 0)}%`}
        direction={data.bottomTextBox.position === 'right' ? 'row' : 'row-reverse'}
      >
        <StyledSplit
          width={`${100 - (data.bottomTextBox.position !== 'none' ? data.bottomTextBox.width : 0)}`}
          minSize={[...Array(data.bottomPhotoList.length)].map(i => 0)}
          sizes={bottomSizes}
          onDragEnd={handleBottomResize}
          snapOffset={0}
          gutterSize={0}
        >
          {
            data.bottomPhotoList.map((item, i) => <PhotoItem key={`${id}_bottom_${i}`} background={item && item.image}></PhotoItem>)
          }
        </StyledSplit>

        <BoxText
          position={data.bottomTextBox.position}
          background={data.bottomTextBox.background}
          width={data.bottomTextBox.width}
        >
          <StyledText
            position={data.bottomTextBoxPosition}
            sizes={data.bottomTextBoxSize}
            color={data.bottomTextBox.color}
            fontSize={data.bottomTextBox.fontSize * moduleWidthCoef}
            dangerouslySetInnerHTML={{__html: data.bottomText}}
          ></StyledText>
        </BoxText>
      </Box>

      { nextButtonShow && !previewMode &&
          <NextButton onClick={(e) => onNext({
            name: 'Photo',
            id: id,
            // data: {
            //   topData: topSizes.map(i => Number((i).toFixed(2))),
            //   bottomData: bottomSizes.map(i => Number((i).toFixed(2)))
            // },
            data: {
              topData: topSizes.map((item, i) => ({
                text: data.topNameList[i],
                value: Number((item).toFixed(2)),
              })),
              bottomData: bottomSizes.map((item, i) => ({
                text: data.bottomNameList[i],
                value: Number((item).toFixed(2)),
              }))
            },
          })}/>
       }

    </ModuleFrame>
  );
};

const Box = styled.div`
  height: ${props => props.height};
  display: flex;
  flex-direction: ${props => props.direction};
  user-select: none;
  & .gutter-horizontal {
    background: #fff;
    height: 100%;
    box-shadow: 0 0 0 1px #999;
    position: relative;
    cursor: col-resize;
  }
  & .gutter-horizontal:before {
    content: '';
    position: absolute;
    left: -35px;
    top: 0;
    bottom: 0;
    margin: auto;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8' %3F%3E%3Csvg version='1.1' width='100px' fill='%23${props => props.sliderColor}' height='100px' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 240 212' style='enable-background:new 0 0 224 224;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D .st1%7Bfill:none;stroke:%23fff;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D%0A%3C/style%3E%3Cg id='Layer_1'%3E%3Ccircle class='st0' cx='119.4' cy='106.6' r='77.9' /%3E%3Ccircle cx='119.4' cy='106.6' r='71.4' /%3E%3Cg%3E%3Cpath d='M5335.1,2462.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4 c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5334.4,2465.7,5335.1,2463.9,5335.1,2462.1z M5325.4,2462c-4.8,0-7.4-1.3-7.5-1.8l0,0c0.1-0.5,2.7-1.8,7.5-1.8s7.3,1.3,7.5,1.8C5332.7,2460.7,5330.2,2462,5325.4,2462z' /%3E%3Cpath d='M5330.4,2472.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h4.3c0.6,0,1-0.4,1-1s-0.4-1-1-1H5330.4z' /%3E%3Cpath d='M5334.7,2475.7h-4.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5335.7,2476.1,5335.3,2475.7,5334.7,2475.7z' /%3E%3Cpath d='M5334.7,2479h-4.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5335.7,2479.5,5335.3,2479,5334.7,2479z' /%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3Cpath class='st1' d='M113.8,116V95.4c0-3.1,2.5-5.7,5.7-5.7h0c3.1,0,5.7,2.5,5.7,5.7v28.4' /%3E%3Cpath class='st1' d='M125.1,123.8v-4.6c0-3.1,2.5-5.7,5.7-5.7h0c3.1,0,5.7,2.5,5.7,5.7v7.8' /%3E%3Cpath class='st1' d='M136.4,127.3v-4.6c0-3.1,2.5-5.7,5.7-5.7h0c3.1,0,5.7,2.5,5.7,5.7v7.8' /%3E%3Cpath class='st1' d='M147.8,130.9v-4.6c0-3.1,2.5-5.7,5.7-5.7h0c3.1,0,5.7,2.5,5.7,5.7v21.8' /%3E%3Cpath class='st1' d='M107.1,149L97,138.9c-2.4-2.4-2.4-6.2,0-8.5l0,0c2.4-2.4,6.2-2.4,8.5,0l8.2,8.2l0-22.6' /%3E%3Cg%3E%3Cg%3E%3Cline class='st1' x1='94.1' y1='89.7' x2='69.3' y2='89.7' /%3E%3Cpolyline class='st1' points='78,100.2 67.5,89.7 78,79.3 ' /%3E%3C/g%3E%3Cg%3E%3Cline class='st1' x1='144.7' y1='89.7' x2='169.5' y2='89.7' /%3E%3Cpolyline class='st1' points='160.9,79.3 171.4,89.7 160.9,100.2 ' /%3E%3C/g%3E%3C/g%3E%3Cpath class='st1' d='M130.7,101.4c3-2.9,4.9-7.1,4.9-11.6c0-8.9-7.2-16.2-16.2-16.2c-8.9,0-16.2,7.2-16.2,16.2 c0,4.6,1.9,8.7,4.9,11.6' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 140%;
    width: 70px;
    height: 70px;
    @media (max-width: 1200px) {
      width: 60px;
      height: 60px;
      left: -30px;
    }
    @media (max-width: 900px) {
      width: 50px;
      height: 50px;
      left: -25px;
    }
    @media (max-width: 600px) {
      width: 30px;
      height: 30px;
      left: -15px;
    }
  }
`;

const StyledSplit = styled(Split)`
  width: ${props => props.width + '%'};
  height: 100%;
  display: flex;
  flex-direction: row;
`;

const PhotoItem = styled.div`
  width: 100%;
  height: 100%;
  background: ${props => props.background ? `url(${props.background})` : '#fff'};
  background-position: center;
  background-size: cover;
`;

const BoxText = styled.div`
  overflow: hidden;
  display: ${props => props.position === 'none' ? 'none' : 'block'};
  width: ${props => props.width + '%'};
  height: 100%;
  text-align: center;
  background: ${props => props.background};
  position: relative;
`;

const StyledText = styled.div`
  width: ${props => props.sizes[0] + '%'};
  height: ${props => props.sizes[1] + '%'};
  position: absolute;
  top: ${props => props.position[1] + '%'};
  left: ${props => props.position[0] + '%'};
  text-align: center;
  font-size: ${props => 0.4 * props.fontSize + 'vw'} !important;
  overflow: hidden;
  color: ${props => props.color};
  line-height: 1.2;
  user-select: none;
`;

const MiddleText = styled.div`
  overflow: hidden;
  z-index: 1;
  display: ${props => props.position === 'none' ? 'none' : 'block'};
  ${props => props.position === 'cover' ? `
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  ` : `
    position: relative;
  `}
  width: ${props => props.width + '%'};
  height: ${props => props.height + '%'};
  text-align: center;
  background: ${props => props.background};
`;
